export const isValidPhoneNumber = (value: any) => {
  return !value || /^$|([\d]{10})/.test(value) ? undefined : 'Invalid Phone Number';
};

export const isRequired = (value: any) => (value ? undefined : 'Required');

export const isValidEmail = (value: string): string | undefined => {
  return /\S+@\S+\.\S+/.test(value) ? undefined : 'Invalid Email';
};

export const isValidMessage = (value: string): string | undefined => {
  return /^[\w,;:#&@%()'"\s.?!/|/$\\]*$/.test(value) ? undefined : 'Invalid Message';
};

export const isEightCharacters = (value: string): string | undefined => {
  return value && value.length === 8 ? undefined : 'Must be exactly 8 characters';
};

export const isThreeDigits = (value: string): string | undefined => {
  return /^[0-9]+$/.test(value) && value && value.length === 3 ? undefined : 'Must be exactly 3 digits';
};

export const domainNamePattern = /[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+\.?/;

export const composeValidators =
  (...validators: any[]) =>
  (value: string) =>
    validators.reduce((error, validator) => error || validator(value), undefined);
